'use strict';
var m;

angular.module('harriApp')
    .controller('BrandProfilesController', ['$scope', '$state', '$element', 'hUser', 'userPermissions', 'BrandProfileDataBus', 'accessibilityToolsService', 'appLayoutViewService', 'brandServices', 'JobDetailsBus', 'jobApplyFactory', 'hEvent', function ($scope, $state, $element, hUser, userPermissions, BrandProfileDataBus, accessibilityToolsService, appLayoutViewService, brandServices, JobDetailsBus, jobApplyFactory, hEvent) {
        $state.current.reloadOnSearch = undefined;

        var brandId = $state.params.id;
        let talentScoutCodeId = $state.params.talent_scout_code_id;

        $scope.jobsPermission = {};

        var slideIndex = 0;
        var slideInterval;
        $scope.slide = function (value) {
            clearTimeout(slideInterval);
            slideIndex += value;
            var slides = $(".carousel-slides");

            if (slides.length) {
                slideInterval = setTimeout(function () {
                    $scope.slide(1);
                }, 4000);
                if (slideIndex < 0) {
                    slideIndex = slides.length - 1;
                } else if (slideIndex === slides.length) {
                    slideIndex = 0;
                }
                for (var i = 0; i < slides.length; i++) {
                    slides[i].style.display = 'none';
                }
                slides[slideIndex].style.display = 'block';
            }
        };

        $scope.slide(0);

        let loadBrandProfile = () => {

            var data = BrandProfileDataBus.getData();
            var jobs = data.Jobs;
            var draftJobs = data.draft_Jobs;
            $scope.isEmployer = hUser.isEmployer();

            var allJobs = jobs.concat(draftJobs);

            if (data.accessibility_tool_settings && data.accessibility_tool_settings.accessibility_usage_allowed) {
                accessibilityToolsService.initAccessibilityTool(data.accessibility_tool_settings);
                $scope.isAccessibilityButtonShown = true;
            } else {
                accessibilityToolsService.hideAccessibilityTool();
            }

            if (brandId && $scope.isEmployer) {
                userPermissions.getBrandPolicy(brandId)
                    .then(function (policyParser) {
                        $scope.hasJobPostPermission = policyParser.hasAny(userPermissions.CREATE_JOB_PERMISSIONS);

                        for (var i in allJobs) {
                            var job = allJobs[i].Job;
                            var positionCategory = job.Position[0].category.code;
                            var positionCode = job.Position[0].code;
                            var jobType = job.JobType[0].name;
                            var jobId = job.id;
                            if (jobType == "PUBLISHED" && !job.template_id) {
                                $scope.jobsPermission[jobId] = policyParser.position(positionCategory, positionCode).has(userPermissions.PERMISSIONS.CREATE_EDIT_JOB_POST);
                            }
                            else {
                                $scope.jobsPermission[jobId] = policyParser.position(positionCategory, positionCode).hasAny(userPermissions.CREATE_JOB_PERMISSIONS);
                            }
                        }

                        $scope.canManageBrandDetails = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BRAND_DETAILS);
                    })
                    .catch(function (err) {
                        console.error(err);
                    });

            }

            var profileImage;
            var rectangleProfileImage;
            if (data.BrandMedia) {
                profileImage = _.findWhere(data.BrandMedia, {'type': 'profile_image'});
                rectangleProfileImage = _.findWhere(data.BrandMedia, {'type': 'rectangle_profile_image'});
            }
            appLayoutViewService.updateBrandTheme({
                scheme_settings: data.scheme_settings,
                profile_image: profileImage || null,
                rectangle_profile_image: rectangleProfileImage || null,
            }, 'brand_profile_theme', $element.find('.h-brand').context)
                .finally(function () {
                    $scope.$evalAsync();
                });

            if (data.id && !$scope.isEmployer) {
                if (data.public_services?.includes('GLOBAL_TALENT_POOL') &&
                    data.global_talent_pool_settings?.apply_to_talent_pool) {
                    CoreReaderAPI.getTalentPoolJobs(data.id)
                        .then(talentPoolJob => {
                            if (talentPoolJob?.id) {
                                $scope.isApplyTalentPoolEnabled = true;
                                $scope.talentPoolJob = talentPoolJob;

                                const isPrivateLink = data.isPrivateLink;
                                const baseUrl = `${isPrivateLink ? '/internal/' : ''}${data.slug}`;
                                $scope.talentPoolApplyUrl = `${baseUrl}/apply/${$scope.talentPoolJob.id}${talentScoutCodeId ? `?talent_scout_code_id=${talentScoutCodeId}` : ''}`;

                                $scope.$evalAsync();
                            }
                        })
                        .catch(error => {
                            console.error("Error fetching talent pool jobs:", error);
                        });
                }
            }

        };

        JobDetailsBus.onJobApplyFinish = async (status, appId, applyDate, jobId) => {
            if ([JobDetailsBus.SUCCESS, JobDetailsBus.SUCCESS_NO_PASSWORD].indexOf(status) > -1) {
                jobApplyFactory.PrepareApplySuccessModal(jobId).then((data)=>{
                    $.extend($scope, data)
                    jobApplyFactory.showApplySuccessModal();
                    $scope.$digest();
                });
            }
        };

        $scope.showAccessibilityTools = function () {
            accessibilityToolsService.showAccessibilityTool();
        };

        loadBrandProfile();

        $scope.onSearchOpen = function (isShown) {
            $scope.searchOpen = isShown;
            $scope.$evalAsync();
        };

        $scope.isSideBarExpanded = function () {
            return appLayoutViewService.isSideBarExpanded();
        };

        $scope.getToggleSource = function () {
            return appLayoutViewService.getToggleSource();
        };

        $scope.$on("$destroy", function () {
            BrandProfileDataBus.cleanData();
        });
    }]);